<template>
	<div class="login-wrapper">
		<div class="login-container">
			<!-- Left Column - Login Content -->
			<div class="login-content">
				<div class="login-inner-content px-5">
					<div class="w-100">
						<!-- Logo -->
						<div class="text-center text-lg-start mb-5">
							<img src="/src/assets/logo_home.png" alt="logo" class="img-fluid mb-4 py-4"
								 style="max-width: 250px;">
							<h1 class="login-title text-primary">
								Notes de frais
							</h1>
							<p class="login-subtitle montserrat d-none d-lg-block">Gestion des notes de frais et
								congés</p>
						</div>

						<!-- Main Login Button -->
						<div v-if="loginMode === 'user'">
							<button
								class="btn custom-btn btn-lg w-100 py-3 mb-3 d-flex align-items-center justify-content-center gap-2"
								@click="loginWithOauth">
								<i class="fab fa-microsoft fs-4"></i>
								<span>Connexion avec Office 365</span>
							</button>
							<p class="text-muted">
								<i class="fas fa-info-circle"></i>
								Utilisez votre compte Teams ou Sharepoint
							</p>
						</div>

						<!-- Dev Login Section -->
						<div v-if="getIsDev&&loginMode === 'dev'" class="mt-5">
							<div v-if="haveerror" class="alert alert-danger d-flex align-items-center"
								 role="alert">
								<i class="fas fa-exclamation-triangle me-2"></i>
								Erreur de connexion
							</div>

							<form @submit.prevent="loginWithInput">
								<div class="mb-3">
									<label class="form-label montserrat fw-bold text-primary">Identifiant</label>
									<input type="text"
										   v-model="login"
										   class="form-control form-control-lg"
										   placeholder="Identifiant">
								</div>
								<div class="mb-4">
									<label class="form-label montserra fw-bold text-primary">Mot de passe</label>
									<input type="password"
										   v-model="password"
										   class="form-control form-control-lg"
										   placeholder="Mot de passe">
								</div>
								<div class="d-grid gap-2">
									<button class="btn custom-btn py-3 fw-bold" type="submit">CONNEXION</button>
									<button class="btn custom-btn-outline fw-bold" @click="refresh" type="button">
										ACTUALISER
									</button>
								</div>
							</form>
						</div>

						<!-- Login Mode Selector -->
						<div v-if="getIsDev" class="mb-2 my-5 text-muted montserrat">
							Mode de connexion
						</div>
						<div v-if="getIsDev" class="btn-group w-100 mb-4" role="group" aria-label="Mode de connexion">
							<div class="d-flex align-items-center">
								<input type="radio" name="loginMode" id="userMode" v-model="loginMode"
									   value="user" autocomplete="off" checked>
								<label for="userMode">Mode utilisateur</label>
							</div>

							<div style="margin-left: 20px" class="d-flex align-items-center">
								<input type="radio" name="loginMode" id="devMode" v-model="loginMode"
									   value="dev" autocomplete="off">
								<label for="devMode">Mode développeur</label>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Right Column - Background Image -->
			<div class="login-image bg-primary-dark">
				<img src="/src/assets/login_visuel5.png"
					 alt="Background"
					 class="img-fluid"
					 style="opacity: 0.4;">
			</div>
		</div>
	</div>
</template>

<script>
import {createRouter as $router} from "vue-router/dist/vue-router.esm-browser.js";
import {logError} from "../../plugins/logger.js";
import {mapGetters} from "vuex";

export default {
	data() {
		return {
			login: '',
			password: '',
			haveerror: false,
			loginMode: 'user',
		}
	},
	computed: {
		...mapGetters(['getIsDev']),
	},
	methods: {
		loginWithInput: async function (e) {
			this.haveerror = false;
			this.$store.dispatch('loginWithInput', {login: this.login, password: this.password})
				.then(res => {
					if (!res) {
						this.haveerror = true;
					} else {
						window.location.reload();
					}
				})
				.catch(e => {
					this.haveerror = true;
					logError('login.password', e, {});
				});
		},
		loginWithOauth: async function () {
			// Popup fermée par l'utilisateur ou flux OAuth interrompu : sans ce
			// catch la promesse partait en unhandledrejection et la page se
			// rechargeait quand même, toujours déconnectée.
			try {
				this.haveerror = await this.$store.dispatch('login');
				window.location.reload();
			} catch (e) {
				this.haveerror = true;
				logError('login.oauth', e, {});
			}
		},
		refresh: function () {
			this.$store.dispatch('refresh').catch(e => logError('login.refresh', e, {}));
		}
	}
}
</script>

<style scoped>
.text-primary {
	color: #1f1f54 !important;
}

@font-face {
	font-family: 'DM Sans';
	src: url('/src/assets/DMSans-Bold.ttf') format('truetype');
	font-weight: bold;
	font-style: normal;
}

@font-face {
	font-family: 'Montserrat';
	src: url('/src/assets/Montserrat-Medium.ttf') format('truetype');
	font-weight: 500;
	font-style: normal;
}

.login-title {
	font-family: 'DM Sans', sans-serif;
	font-size: 50px;
	font-weight: bold;
	margin-bottom: 0.5rem;
}

.montserrat {
	font-family: 'Montserrat', sans-serif;
}

.login-subtitle {
	color: #9fa5a9;
	font-size: 22px;
	font-weight: 500;
	margin-bottom: 2rem;
}

.login-wrapper {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	overflow: hidden;
}

.login-container {
	display: flex;
	width: 100%;
	height: 100%;
}

.login-content {
	flex: 1;
	max-width: 50%;
	height: 100%;
	overflow-y: auto;
	background: white;
}

.login-inner-content {
	max-width: 700px;
	margin: 0 auto;
	padding: 1rem;
	width: 100%;
}

@media (min-width: 992px) {
	.login-inner-content {
		padding: 1.5rem;
	}
}

.login-image {
	flex: 1;
	max-width: 50%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.login-image img {
	max-width: 90%;
	max-height: 90%;
	width: auto;
	height: auto;
}

@media (max-width: 991.98px) {
	.login-content {
		max-width: 100%;
	}

	.login-image {
		display: none;
	}
}

.bg-primary-dark {
	background-color: #1f1f54;
}

.custom-btn {
	background-color: #ffb10a;
	border: 1px solid #ffb10a;
	color: white;
	border-radius: 50px;
	transition: all 0.3s ease;
}

.custom-btn:hover {
	background-color: transparent;
	border-color: #ffb10a;
	color: #ffb10a;
}

.custom-btn-outline {
	background-color: transparent;
	border: 2px solid #ffb10a;
	color: #ffb10a;
	border-radius: 50px;
	transition: all 0.3s ease;
	padding: 0.5rem 1rem;
}

.custom-btn-outline:hover {
	background-color: #ffb10a;
	color: white;
}

/* Style radio classique */
input[type="radio"] {
	appearance: none;
	width: 16px;
	height: 16px;
	border: 2px solid #ffb10a;
	border-radius: 50%;
	margin-right: 8px;
	position: relative;
	cursor: pointer;
}

input[type="radio"]:checked::after {
	content: "";
	position: absolute;
	width: 8px;
	height: 8px;
	background-color: #ffb10a;
	border-radius: 50%;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
</style>
